import { toastDanger, toastSuccess } from '@/services/prompts'

export function copyText (input, successMessage, vm) {
  navigator.permissions.query({name: "clipboard-write"}).then(result => {
    if (['granted', 'prompt'].includes(result.state)) {
      // copy was allowed
      navigator.clipboard.writeText(input)
      if (vm) {
        toastSuccess(vm, successMessage || 'Copied into clipboard')
      }
    } else {
      // let the user phone we weren't allowed
      if (vm) {
        toastDanger(vm, 'Browser permissions refused')
      }
    }
  })
}